import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/camillacinodd_theme.ts';
import App from './App.tsx';
//import "./i18n";
import HelmetWrapper from './helmetWrapper.tsx';

const rootElement = document.getElementById('root') as HTMLElement;

const AppWrapper = (
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HelmetWrapper>
        <App />
      </HelmetWrapper>
    </ThemeProvider>
  </React.StrictMode>
);

// Se il contenuto è già pre-renderizzato (react-snap), usa hydrateRoot
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, AppWrapper);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(AppWrapper);
}
